import { CSSProperties } from 'react';
import { Box } from '@mui/material';
import { TaskAlt as TaskAltIcon } from '@mui/icons-material';

function AlertFullWidth({ children, sx }: { children: React.ReactNode, sx?: CSSProperties }) {
	return (
		<Box sx={{
			...sx,
			padding: '14px 16px',
			display: 'flex',
			alignItems: 'center',
			color: 'rgb(30, 70, 32)',
			borderRadius: '4px',
			backgroundColor: 'rgb(237, 247, 237)',
			width: '100%'
		}}>
			<Box sx={{
				padding: '7px 12px 7px 0'
			}}>
				<TaskAltIcon
					sx={{ color: 'rgb(46, 125, 50)' }}
				/>
			</Box>
			<Box
				sx={{
					flexGrow: 1
				}}
			>
				{children}
			</Box>
		</Box>
	);
}

export default AlertFullWidth;